import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

export const measurementUnit = {
  VALUE: 0,
  PALLETS: 1,
  VOLUME: 2,
  WEIGHT: 3,
  UNITS: 4,
};

export const measurementUnitToFieldName = {
  [measurementUnit.VALUE]: 'value',
  [measurementUnit.PALLETS]: 'pallets',
  [measurementUnit.VOLUME]: 'volume',
  [measurementUnit.WEIGHT]: 'weight',
  [measurementUnit.UNITS]: 'units',
};

export const getMeasurementUnitFieldName = viewUnit =>
  measurementUnitToFieldName[viewUnit];

export const measurementUnitSuffix = {
  [measurementUnit.VALUE]: '',
  [measurementUnit.PALLETS]: 'PAL',
  [measurementUnit.VOLUME]: 'm³',
  [measurementUnit.WEIGHT]: 'kg',
  [measurementUnit.UNITS]: 'U',
};

export const getMeasurementUnitSuffix = viewUnit =>
  measurementUnitSuffix[viewUnit];

const propTypes = {
  unit: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const defaultProps = {
  unit: '',
  value: '',
};

class MeasurementValue extends Component {
  render() {
    const { unit, value } = this.props;

    if (unit === measurementUnit.VALUE) {
      return (
        <FormattedNumber
          // -disable-next-line react/style-prop-object
          style="currency"
          minimumFractionDigits={2}
          maximumFractionDigits={2}
          currency="BRL"
          currencyDisplay="symbol"
          value={value}
          useGrouping
        />
      );
    }

    return (
      <span>
        <FormattedNumber value={value} maximumFractionDigits={2} />
        {` ${getMeasurementUnitSuffix(unit)}`}
      </span>
    );
  }
}

MeasurementValue.propTypes = propTypes;
MeasurementValue.defaultProps = defaultProps;

export default MeasurementValue;
